// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"pageNotFound_wrapper__NyfT3","code":"pageNotFound_code__rYDAz","status":"pageNotFound_status__oYhQW"};